import { formatOneDigitNumber, plainAverage } from '@utils/formatters';

import createColumn from './createColumn';
export const heightSignal = {
    format: formatOneDigitNumber,
    average: plainAverage,
};

export const drivenElevationUp = createColumn({
    key: 'drivenElevationUp',
    dataField: 'drivenElevationUp',
    labelId: 'drivenElevationUp',
    formatter: heightSignal.format,
});
export const drivenElevationDown = createColumn({
    key: 'drivenElevationDown',
    dataField: 'drivenElevationDown',
    labelId: 'drivenElevationDown',
    formatter: heightSignal.format,
});
